import React from 'react';
import _get from 'lodash/get';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core';
import { Theme } from 'styles/ThemeTyping';

import Typography from '@material-ui/core/Typography';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Tooltip from '@material-ui/core/Tooltip';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';

interface Props {
  icon: React.ReactNode;
  displayName: string;
  disabled?: boolean;
  checked: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

function MetricItem({ icon, displayName, disabled, checked, onChange }: Props) {
  const classes = useStyles();

  const managerTerminology = useSelector(state =>
    _get(state, 'client.terminology.teamLeader', 'manager'),
  );

  const tooltipLookup = {
    'Direct Report Count': `The number of people who directly report to a ${managerTerminology}.`,
    'Total Report Count': `The total number of people who directly and indirectly report to a ${managerTerminology}.`,
    'Dotted Line Report Count': `The number of dotted line relationships a person has.`,
    'Open Role Report Count': `The number of Open Roles a person has on their team.`,
  };

  return (
    <div className={classes.root}>
      <FormControlLabel
        control={
          <Switch
            disabled={disabled}
            size="small"
            className={classes.switchMargin}
            checked={checked}
            onChange={onChange}
          />
        }
        label={
          <span className={classes.label}>
            <div className={classes.iconContainer}>{icon}</div>
            <Typography variant="body2" className={disabled ? classes.disabled : ''}>
              {displayName}
            </Typography>
            {/* @ts-ignore */}
            <Tooltip title={tooltipLookup[displayName]} placement="top" arrow>
              <InfoOutlinedIcon
                className={classNames(classes.info, disabled && classes.disabled)}
              />
            </Tooltip>
          </span>
        }
        labelPlacement="end"
      />
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    height: 41,
    width: '100%',
    marginLeft: theme.spacing(1.375),
  },
  label: {
    display: 'flex',
    alignItems: 'center',
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxHeight: 16,
    maxWidth: 16,
    marginRight: theme.spacing(1.25),
  },
  disabled: {
    color: theme.palette.text.gray1,
  },
  info: {
    maxHeight: 16,
    maxWidth: 16,
    marginLeft: theme.spacing(0.5),
  },
  switchMargin: {
    marginRight: theme.spacing(2.25),
  },
}));

export default MetricItem;
